import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { XCircle, ArrowLeft, HelpCircle } from 'lucide-react';

const PaymentCancel = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-12 bg-slate-50/50">
      <div className="max-w-md w-full bg-white rounded-[2.5rem] shadow-2xl shadow-slate-200/50 border border-slate-100 overflow-hidden animate-in zoom-in duration-500">

        {/* Header Section */}
        <div className="bg-red-500 p-10 text-center relative">
          <div className="w-20 h-20 bg-white/20 rounded-3xl mx-auto flex items-center justify-center text-white mb-4 animate-bounce-subtle">
            <XCircle size={48} strokeWidth={1.5} />
          </div>
          <h1 className="text-2xl font-black text-white uppercase tracking-wider">
            {t('payment.Zahlung abgebrochen', 'Zahlung abgebrochen')}
          </h1>

          {/* Subtle decoration */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-full -mr-16 -mt-16 blur-2xl" />
        </div>

        {/* Content Section */}
        <div className="p-10 text-center space-y-8">
          <div className="space-y-4">
            <p className="text-slate-500 font-medium leading-relaxed">
              {t('payment.AbbruchMessage', 'Der Zahlungsvorgang wurde abgebrochen. Es wurden keine Gebühren berechnet.')}
            </p>
            <p className="text-sm text-slate-400">
              {t('payment.FragenMessage', 'Sollten Sie Probleme bei der Zahlung haben, steht Ihnen unser Support jederzeit zur Verfügung.')}
            </p>
          </div>

          <div className="w-full h-px bg-slate-100" />

          {/* Action Buttons */}
          <div className="grid gap-4">
            <button
              onClick={() => navigate('/pakete')}
              className="w-full h-14 bg-[#0f7699] text-white rounded-2xl font-black uppercase tracking-widest text-xs shadow-lg shadow-sky-900/20 hover:bg-[#0d6b8a] transition-all active:scale-[0.98] flex items-center justify-center space-x-2"
            >
              <ArrowLeft size={18} />
              <span>{t('buttons.backToPackages', 'Zurück zur Auswahl')}</span>
            </button>

            <button
              onClick={() => navigate('/docs')}
              className="w-full h-14 bg-slate-50 text-slate-600 border border-slate-100 rounded-2xl font-black uppercase tracking-widest text-xs hover:bg-slate-100 transition-all active:scale-[0.98] flex items-center justify-center space-x-2"
            >
              <HelpCircle size={18} />
              <span>{t('buttons.support', 'Hilfe erhalten')}</span>
            </button>
          </div>
        </div>

        {/* Footer info */}
        <div className="bg-slate-50/80 p-6 text-center">
            <p className="text-[10px] font-black uppercase tracking-widest text-slate-400 italic">
                3D Medico Secure Payment
            </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
